module.exports = __webpack_public_path__ + "images/emoji/camera.38e1db7408b12befbe7f.png";